import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const auditAPI = {
    getLogs: (params) => axios.get(`${API_URL}/api/admin/audit-log`, { params }),
};
